import type {ReactNode} from "react";
import {DsField} from "@zaaaz/ui";

type FormFieldProps = {
  error?: string;
  className?: string;
  children: ReactNode;
};

export function FormField({error, className, children}: FormFieldProps) {
  const cls = ["cc-field", className].filter(Boolean).join(" ");
  return (
    <DsField error={error}>
      <div className={cls}>{children}</div>
    </DsField>
  );
}
